<template>
  <van-form @submit="doSave" validate-trigger="onSubmit">
    <!-- 基本信息 -->
    <!-- <div v-if="optionalFlag" class="optional-flag">选填</div> -->
    <div>
      <div class="form-title">
        <span class="font-bigger">{{ title }}</span>
        <span v-if="tips" class="tips">{{ tips }}</span>
      </div>
    </div>
    <!-- 按数据配置，生成表单 -->
    <div v-for="(item, index) in fields" :key="index">
      <div v-if="showMethod(item)">
        <!-- 不同类型，显示不同标签 -->
        <div class="field-container">
          <van-field
            :id="item.code"
            error
            :border="false"
            :required="item.required"
            :name="item.code"
            :label="item.label"
          />
          <div v-if="item.type.key == 'CheckBox'" class="type">（单选或多选）</div>
          <!-- <div v-if="item.type == 'Radio'" class="type">（单选）</div> -->
        </div>
        <!-- error -->
        <div v-if="errorCode == item.code" class="error-msg">{{ errorMsg }}</div>
        <!-- desc -->
        <div v-if="item.intro" v-html="item.intro" class="desc"></div>
        <!-- tags -->
        <div v-if="item.tags && item.tags.length > 0" class="tags">
          <div v-for="(tag,tagIndex) in item.tags" :key="tagIndex">{{ tag }}</div>
        </div>
        <!-- 多选类型 -->
        <div v-if="item.type.key == 'CheckBox'" class="form-content">
          <van-checkbox-group :disabled="disabled" v-model="formData[item.code]">
            <van-checkbox v-for="(option, optionIndex) in item.data" @click="changeOption(option, item.data, item.code)" :key="optionIndex" :name="option.value" checked-color="#FB993A">{{ option.label }}</van-checkbox>
          </van-checkbox-group>
        </div>
        <!-- 单选类型 -->
        <div v-if="item.type.key == 'Radio'" class="form-content">
          <van-radio-group :disabled="disabled" v-model="formData[item.code]">
            <van-radio v-for="(option, optionIndex) in item.data" :key="optionIndex" :name="option.value" checked-color="#FB993A">{{ option.label }}</van-radio>
          </van-radio-group>
        </div>
        <!-- 输入类型 -->
        <div v-if="item.type.key == 'Input'" class="form-content">
          <input :disabled="disabled" v-model="formData[item.code]" class="form-input" />
        </div>
      </div>
    </div>
    <!-- 提示 -->
    <div v-if="!optionalFlag" class="tipCoin">此项为选填项，可跳过</div>
  </van-form>
</template>

<script>
var storageData = {}
window.addEventListener('setItemEvent', function (e) {
  storageData[e.key] = e.newValue
})
import { Toast } from "vant"
import { dealCondition } from '@/utils/tools'
export default {
  components: {},
  props: {
    baseData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    month: {
      type: Number
    },
    sex: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array
    },
    title: {
      type: String,
      default: "默认表单",
    },
    tips: {
      type: String,
      default: "",
    },
    optionalFlag: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      recordCache: {},
      errorCode: '',
      errorMsg: '',
      formData: {},
    };
  },
  watch: {
    month(val) {
      localStorage.setItem('month', val)
    },
    sex(val) {
      localStorage.setItem('sex', val)
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    showMethod(item) {
      // 处理condition
      var flag = true
      item.conditions.forEach(it => {
        var data = ''
        if (it.conditionCode == 'month') {
          data = this.month
        } else if (it.conditionCode == 'sex') {
          console.info(this.sex)
          data = this.sex
        } else if (storageData[it.conditionCode]) {
          data = storageData[it.conditionCode]
        } else if (localStorage.getItem(it.conditionCode)) {
          data = localStorage.getItem(it.conditionCode)
        } else {
          data = this.formData[it.conditionCode]
        }
        if (it.type.key == 'Between') {
          flag = (data > it.minValue && data < it.maxValue)
        }
        if (it.type.key == 'Equal') {
          flag = (data == it.equalValue)
        }
        if (it.type.key == 'NotEqual') {
          flag = (data != it.equalValue)
        }
        if (it.type.key == 'Include') {
          flag = (it.includeVale.indexOf(data) >= 0)
        }
        // if (item.minMonth && this.month <= item.minMonth) {
        //   return false
        // }
        // if (item.maxMonth && this.month > item.maxMonth) {
        //   return false
        // }
        // // 依赖字段选项
        // if (item.showKey && this.formData[item.showKey] != item.showVlue) {
        //   return false
        // }
        // if (item.baseDataLimit) {
        //   item.baseDataLimit.forEach(e => {
        //     if (flag && this.baseData[e.code]) {
        //       flag = e.value.indexOf(parseInt(this.baseData[e.code])) >= 0
        //     }
        //   })
        //   return flag
        // }
      })
      return flag
    },
    changeOption(option, options, code) {
      var array = []
      if (option.only) {
        array.push(option.value)
      } else {
        options.forEach(e => {
          if (this.formData[code].indexOf(e.value) >= 0 && !e.only) {
            array.push(e.value)
          }
        })
      }
      this.$set(this.formData, code, array)
    },
    resetData(data) {
      this.recordCache = data
      this.$nextTick(() => {
        this.errorCode = ''
        this.errorMsg = ''
        this.formData = {}
        this.fields.forEach(e => {
          var item = data[e.code]
          if (item) {
            if (item.type.key == 'Radio') {
              // 单选
              this.$set(this.formData, e.code, item.valueOfRadio)
            }
            if (item.type.key == 'CheckBox') {
              // 多选
              this.$set(this.formData, e.code, item.valueOfCheckBox)
            }
            if (item.type.key == 'Switch') {
              // 判断
              this.$set(this.formData, e.code, item.valueOfSwitch)
            }
            if (item.type.key == 'Input') {
              // 判断
              this.$set(this.formData, e.code, item.valueOfInput)
            }
          }
        })
      })
    },
    doSave() {
      this.errorCode = ''
      this.errorMsg = ''
      // 检查表单
      return new Promise((resolve, reject) => {
        var vaild = true
        this.fields.forEach(e => {
          if (e.required && vaild && this.showMethod(e)) {
            if ((!this.formData[e.code] && this.formData[e.code] != 0) || (this.formData[e.code] && this.formData[e.code].length == 0)) {
              Toast(e.requiredMsg ? e.requiredMsg : '该字段必选')
              vaild = false
              this.errorCode = e.code
              this.errorMsg = e.requiredMsg ? e.requiredMsg : '该字段必选'
              // 滚到指定位置
              let targetElement = document.getElementById(this.errorCode)
              let scrollHeight = targetElement.getBoundingClientRect().top + window.scrollY - 100
              window.scroll({
                top: scrollHeight,
                behavior: 'smooth'
              })
            }
          }
        })
        if (vaild) {
          // 完善字段提交
          var formData = {}
          for(var p in this.recordCache){//遍历json数组时，这么写p为索引，0,1
            var item = this.recordCache[p]
            formData[item.code] = item
            if (item.type.key == 'Radio') {
              // 单选
              formData[item.code].valueOfRadio = this.formData[item.code]
            }
            if (item.type.key == 'CheckBox') {
              // 多选
              Object.assign(formData[item.code].valueOfCheckBox, this.formData[item.code])
            }
            if (item.type.key == 'Switch') {
              // 判断
              Object.assign(formData[item.code].valueOfSwitch, this.formData[item.code])
            }
            if (item.type.key == 'Input') {
              // 输入
              formData[item.code].valueOfInput = this.formData[item.code]
            }
          }
          // 提交
          resolve(formData)
        } else{
          reject()
        }
      })
    },
  },
};
</script>

<style scoped lang="less">
@import url('../../assets/css/style.css');
.user-info {
  width: 100%;
  padding-bottom: 80px;
  .van-cell {
    font-size: 16px;
    /*
  设置input字号为16 可解决ios软键盘弹出，页面缩放问题
  */
  }
  .van-stepper {
    /deep/.van-stepper__input {
      width: 50%;
    }
    /deep/.van-stepper__plus {
      background-color: #FB993A;
    }
    /deep/.van-stepper__minus {
      color: #FB993A;
      border: 1px solid #FB993A;
    }
  }
  .popup-top {
    height: 45px;
    line-height: 45px;
    display: flex;
    justify-content: space-between;
    padding: 0px 15px;
    .top-l {
      color: #999999;
      font-size: 13px;
    }
    .top-c {
      color: #333333;
    }
    .top-r {
      font-size: 13px;
      color: #FB993A;
    }
  }
  .custom-button {
    min-width: 26px;
    color: #fff;
    font-size: 10px;
    line-height: 26px;
    text-align: center;
    background-color: #FB993A;
    border-radius: 100px;
  }
  .custom-button-vice {
    padding: 0px 10px;
    white-space: nowrap;
    color: #fff;
    font-size: 10px;
    line-height: 26px;
    text-align: center;
    background-color: #FB993A;
    border-radius: 100px;
  }
  .right-unit {
    width: 40px;
    text-align: center;
  }
  .form-title {
    margin-top: 8px;
    padding: 8px 16px;
    line-height: 20px;
    background: #f8f8f8;
    .tips {
      color: #FB993A;
      font-size: 14px;
    }
  }
  .footer {
    z-index: 9999;
    width: 100%;
    height: 60px;
    background: #ffffff;
    position: fixed;
    bottom: 0px;
    border-top: 1px solid #f8f8f8;
    .footer-content {
      padding: 10px 14px;
      // display: flex;
      .van-button--round {
        border-radius: 5px;
      }
    }
  }
  .tip-main {
    padding: 20px 15px 10px;
    .tip-top {
      line-height: 45px;
      text-align: center;
      font-size: 0.32rem;
    }
    .tip-content {
      line-height: 35px;
      color: #333;
      margin-bottom: 10px;
    }
    .tip-btm {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 0.32rem;
      color: #bbbbbb;
    }
  }
}
.form-content {
  background: #fff;
  font-size: .38rem;
  padding: 0 16px;
}

.form-input {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 4px 16px;
  height: 48px;
  line-height: 48px;
}

.van-checkbox {
  margin-bottom: 10px;
}
.van-radio {
  margin-bottom: 10px;
}
.desc {
  padding: 0 16px;
  margin-bottom: 16px;
  color: #999999;
  font-size: 0.32rem;
}
.error-msg {
  padding: 0 16px;
  margin-bottom: 16px;
  font-size: 0.32rem;
  color: #FB993A!important;
}
.tags {
  padding: 0 16px;
  margin-bottom: 16px;
  font-size: 0.32rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  div {
    padding: 4px 9px;
    background: rgb(245, 245, 245);
    color: #999999;
    border-radius: 8px;
    margin: 8px 4px 0 0;
  }
}
.field-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  .van-cell {
    width: auto;
    padding: 10px 0 10px 16px;
    word-wrap:break-word;
  }
  /deep/ .van-cell__value {
    display: none;
  }
  /deep/ .van-field__label {
    width: 100%;
    word-wrap:break-word;
  }
  /deep/ .van-cell__title {
    margin-right: 0;
    width: 100%;
    word-wrap:break-word;
  }
  .type {
    font-size: .38rem;
    padding: 10px 0 0 0;
    color: #FB993A;
    flex-wrap: wrap;
  }
}
.optional-flag {
  position: fixed;
  right: 48px;
  bottom: 100px;
}
.tipCoin{
  position: absolute;
  z-index: 2;
  font-size: 0.4rem;
  color: #fff;
  text-align: left;
  bottom: 140px;
  right: 48px;
  background: #A8C71B;
  padding: 8px 10px;
  border-radius: 15px;
  -webkit-animation: fadeOutUp 2s ease 4s 1 both;
}    

.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}
  @-webkit-keyframes fadeOutUp{0%{opacity:1}
  100%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}
}
  @keyframes fadeOutUp{0%{opacity:1}
  100%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}
}

  @-webkit-keyframes fadeOutDown{0%{opacity:1}
  100%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}
}
  @keyframes fadeOutDown{0%{opacity:1}
  100%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}
}
</style>
